export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;

export type PieceType = 'I' | 'J' | 'L' | 'O' | 'S' | 'T' | 'Z';
export type GameMode =
  'garden-break' | 'growing-season' | 'quiet-garden' | 'daily-garden' | 'puzzle-garden';
export type GameStatus = 'ready' | 'playing' | 'paused' | 'over';
export type EndReason =
  'bed-full' | 'season-ended' | 'challenge-complete' | 'pieces-used' | 'garden-ended';

export interface Point {
  readonly x: number;
  readonly y: number;
}

export interface PlantFamily {
  readonly name: string;
  readonly color: number;
  readonly lightColor: number;
  readonly symbol: string;
}

export interface Cell {
  readonly piece: PieceType;
  readonly family: PlantFamily;
}

export type Board = Array<Array<Cell | null>>;

export interface ActivePiece {
  readonly type: PieceType;
  readonly rotation: number;
  readonly x: number;
  readonly y: number;
}

export type GameEvent =
  | { readonly type: 'piece-landed'; readonly cells: readonly Point[] }
  | {
      readonly type: 'rows-cleared';
      readonly count: number;
      readonly rows: readonly number[];
      readonly fullBloom: boolean;
    }
  | { readonly type: 'watering-earned' }
  | { readonly type: 'watering-used'; readonly row: number }
  | { readonly type: 'game-over'; readonly reason: EndReason };

export interface GameSnapshot {
  readonly fullBlooms: number;
  readonly plantedPieces: number;
  readonly canUndo: boolean;
  readonly challengeId: string | null;
  readonly challengeTitle: string | null;
  readonly challengeTarget: number | null;
  readonly challengeMetric: 'rows' | 'blooms' | null;
  readonly challengeProgress: number;
  readonly piecesRemaining: number | null;
  readonly board: Board;
  readonly activePiece: ActivePiece | null;
  readonly ghostY: number | null;
  readonly nextPiece: PieceType;
  readonly nextPieces: readonly PieceType[];
  readonly heldPiece: PieceType | null;
  readonly canHold: boolean;
  readonly pieceId: number;
  readonly mode: GameMode;
  readonly status: GameStatus;
  readonly endReason: EndReason | null;
  readonly score: number;
  readonly lines: number;
  readonly level: number;
  readonly bloomStreak: number;
  readonly bestBloomStreak: number;
  readonly wateringCan: boolean;
  readonly wateringProgress: number;
  readonly timeRemainingMs: number | null;
}
